export {} from './declarations';

export {} from './models';

export {} from './utilities';

import {
  shortcuts,
  kpis,
  recentAssignments,
  mfaPrompt as mfaPromptFeature,
} from './features';
import { withOverlayProvider } from './withOverlayProvider';

// export utility for other packages to reference this pattern
export { withOverlayProvider };

// export wrapped components - automatically includes OverlayProvider
export const shortcutsReducer = shortcuts.reducer;
export const ShortcutsWidget = withOverlayProvider(shortcuts.Component);

export const kpisReducer = kpis.reducer;
export const KpisWidget = withOverlayProvider(kpis.Component);

export const recentAssignmentsReducer = recentAssignments.reducer;
export const RecentAssignmentsWidget = withOverlayProvider(
  recentAssignments.Component
);

// also wrap mfaPrompt.Provider
export const mfaPrompt = {
  ...mfaPromptFeature,
  Provider: withOverlayProvider(mfaPromptFeature.Provider),
};

export {} from './devHarness';
